import React from 'react';
import { Link } from 'react-router-dom';
import CustomHeader from '../components/layout/CustomHeader';
import CustomFooter from '../components/layout/CustomFooter';
import './Home.css';

const Home = () => {
  // Handle smooth scrolling for CTA buttons
  const handleLearnMoreClick = () => {
    const aboutSection = document.querySelector('.about-us-section');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleAboutCTAClick = () => {
    const servicesContainer = document.querySelector('.services-container');
    if (servicesContainer) {
      servicesContainer.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleContactClick = () => {
    // Navigate to contact page
    window.location.href = '/contact';
  };

  return (
    <>
      <CustomHeader activePage="home" />

      {/* Hero Section */}
      <section className="hero" id="home" style={{
        background: `linear-gradient(135deg, rgba(102,126,234,0.7), rgba(118,75,162,0.7)), url("/background.jpg") center center/cover no-repeat`
      }}>
        <div className="floating-products">
          {/* Add your tech products animation/carousel here */}
        </div>
        <h1 className="tagline">
          <span>(I)</span>ntelligent <span>(U)</span>niversal <span>(V)</span>entures
        </h1>
        <button className="cta-button" onClick={handleLearnMoreClick}>Learn More</button>
      </section>

      {/* About Us Section */}
      <section className="about-us-section">
        <div className="about-us-container">
          <h2 className="about-title">About Us</h2>
          <p className="about-description">We are a team of young enthusiastic minds set out on a mission to provide universal tech solutions aiming at easing life with AI enabled technologies</p>
          <p className="about-subdescription">We are into providing software development and production support.</p>
          <button className="about-cta-button" onClick={handleAboutCTAClick}>LEARN MORE</button>
        </div>
        
        <div className="services-container">
          <h3 className="services-title">Our Services</h3>
          <h2 className="services-subtitle">We aim at providing reliable and timely software solutions</h2>
          
          <div className="services-grid">
            <div className="service-tile">
              <h4>Website Development</h4>
              <p>We can quickly build an online presence for your business which will be user friendly and a perfect solution to scale your business</p>
            </div>
            
            <div className="service-tile">
              <h4>ERP Implementation</h4>
              <p>We provide implementation and production support services with the following ERPs –</p>
              <ul>
                <li>Oracle Apps E-Business Suite</li>
                <li>SAP</li>
                <li>CRM – Salesforce</li>
              </ul>
            </div>
            
            <div className="service-tile">
              <h4>Mobile App Development</h4>
              <p>We provide all types of mobile app development</p>
              <ul>
                <li>Android</li>
                <li>iOS</li>
              </ul>
            </div>
          </div>
          
          <div className="solutions-banner">
            <h2>The only place where you'll get the sustainable solution for all your business needs.</h2>
            <button className="contact-cta-button" onClick={handleContactClick}>CONTACT US</button>
          </div>
        </div>
      </section>

      {/* Technologies We Serve Block */}
      <section className="tech-block" aria-label="Technologies We Serve">
        <p className="subtitle">Our Contributions</p>
        <h2 className="title">Technologies We Serve!</h2>
        <div className="tech-grid">
          <article className="tech-item" aria-labelledby="iot-ai-title">
            <img src="/internet.avif" alt="Blue background with white cloud in center connected to multiple small black and white technology icons representing IoT and AI" />
            <h3 id="iot-ai-title">IOT &amp; AI</h3>
            <p>We empower businesses to scale rapidly by harnessing the transformative power of Artificial Intelligence, Machine Learning, and Data Analytics. Our smart solutions unlock hidden opportunities, optimize operations, and drive sustainable growth through data-driven innovation.</p>
          </article>
          <article className="tech-item" aria-labelledby="erp-title">
            <img src="/internet1.webp" alt="Light purple background with a white star in center labeled ERP and surrounding text representing finance, HRMS, sales & distribution, manufacturing, production planning, inventory" />
            <h3 id="erp-title">ERP</h3>
            <p>We provide implementation and production support services with the following ERPs –</p>
            <p>
              Oracle Apps E-Business Suite<br />
              SAP<br />
              CRM – Salesforce
            </p>
          </article>
          <article className="tech-item" aria-labelledby="cloud-computing-title">
            <img src="/internet2.jpg" alt="Cloud computing visualization" />
            <h3 id="cloud-computing-title">Cloud Computing</h3>
            <p>We provide various cloud solutions using available cloud platforms which include –</p>
            <ul>
              <li>AWS</li>
              <li>Google cloud</li>
              <li>Oracle cloud</li>
              <li>MS Azure</li>
            </ul>
          </article>
        </div>
      </section>

      <CustomFooter />
    </>
  );
};

export default Home;